import React, { useState } from 'react'
import {FaBars, FaTimes} from 'react-icons/fa'
import './Navbar.css'
import {Link} from 'react-router-dom'
import headerLogo1 from '../../resources/logo/logo1.png'

const Navbar = () => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);

  const [color, setColor] = useState(false);
  const changeColor = () => {
    if(window.scrollY >= 1){
      setColor(true);
    }else{
      setColor(false);
    }
  };
  window.addEventListener("scroll", changeColor);

  return (
    <header className={color ? "header header-bg" : "header"}>
        {/* <Link to="/"><h3>Menariya</h3></Link> */}
        <Link to="/"><div className='header-logo'><img src={headerLogo1} alt='P'/><h3>ANKAJ</h3></div></Link>
        <nav>
          <ul className={click ? 'navbar active' : 'navbar'}>
            <li><Link to="/" href='#'>Home</Link></li>
            <li><Link to="/project" href='#'>Project</Link></li>
            <li><Link to="/about" href='#'>About</Link></li>
            <li><Link to="/contact" href='#'>Contact</Link></li>
          </ul>
        </nav>
        <div className='hamburger' onClick={handleClick}>
          {click ? (<FaTimes size={20} style={{color: "#fff"}}/>) 
                 : (<FaBars size={20} style={{color: "#fff"}}/>)}          
        </div>
    </header>
  )
}

export default Navbar